import createVueComponent from '../createVueComponent';

const Subscript = createVueComponent('SubscriptIcon', [
  ['path', { d: 'M4 5l8 8' }],
  ['path', { d: 'M12 5l-8 8' }],
  [
    'path',
    {
      d:
        'M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 00-2.62-.44c-.42.24-.74.62-.9 1.07',
    },
  ],
]);

export default Subscript;
